import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, InputBar } from '~/ui';
import { integerRegex } from '~/utils/regex/regex';
import CloseIcon from '~/assets/svg/newSvg/close-cross.svg?react';
import styles from './UserAccuralContent.module.scss';

interface IAccuralProps {
  type: 'add' | 'subtract' | '';
  onSubmit: (points: number) => void;
  onClose: (value: boolean) => void;
  accrualUsersModalOpen: boolean;
}

export const UserAccuralContent = ({
  type,
  accrualUsersModalOpen,
  onSubmit,
  onClose,
}: IAccuralProps) => {
  const [points, setPoints] = useState('');
  const { t } = useTranslation();

  const handleChangePoints = (value: string) => {
    if (value === '' || integerRegex.test(value)) {
      setPoints(value);
    }
  };

  useEffect(() => {
    if (accrualUsersModalOpen === false) {
      setPoints('');
    }
  }, [accrualUsersModalOpen]);

  return (
    <div className={styles.accrualContainer}>
      <p className={styles.accrualTitle}>
        {type === 'add' ? t('accrual_points') : t('debiting_points')}
      </p>
      <div className={styles.accrualActionWrapper}>
        <InputBar
          value={points}
          label={t('loyalty_points')}
          onChange={e => handleChangePoints(e.target.value)}
          classNameInputWrapper={styles.accrualInputWrapper}
          classNameInput={styles.accrualInput}
        />
        <Button
          text={type === 'add' ? t('add') : t('write_off')}
          onClick={() => {
            onSubmit(Number(points));
          }}
          className={styles.accrualButton}
        />
      </div>
      <IconButton
        className={styles.closeButton}
        onClick={() => {
          setPoints('');
          onClose(false);
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};
